(function start() {
  'use strict';
  var open = document.getElementById('pdp-room-open'), dialog = document.getElementById('pdp-room-preview');
  var G = window.AfRoomGeometry;
  if (!open || !dialog || !G || typeof dialog.showModal !== 'function') return;
  if (!window.AfRoomLibrary) {
    var dependency=document.createElement('script');
    dependency.src=new URL('room-library.js',document.currentScript.src).href;
    dependency.onload=start;document.head.appendChild(dependency);return;
  }
  document.body.appendChild(dialog);
  var $ = function (s) { return dialog.querySelector('[data-room-' + s + ']'); };
  var all = function (s) { return Array.from(dialog.querySelectorAll('[data-room-' + s + ']')); };
  var API = 'https://runway.dcomdtf.app/ma-piece-log/perspective';
  var photo = $('photo'), poster = $('poster'), stage = $('stage'), art = $('art'), size = $('size');
  var plan = null, centre = {x:.5,y:.4}, state = 'empty';
  var fileUrl = '', photoUrl = '', blob = null, width = 0, height = 0, epoch = 0, controller = null;
  var timer = 0, dragging = null, choices = [], oldBody = null, scroll = 0;
  var sourceSize = '', errorKey = '';
  var copy = function (key) { return dialog.dataset[key] || ''; };
  var status = function (key) {
    $('status').textContent = copy(key);
    if ($('loading-text')) $('loading-text').textContent = copy(key);
  };
  ['adjust','calibration','wall-controls','guides','corner','point'].forEach(function (name) {
    all(name).forEach(function (node) { node.remove(); });
  });
  function setState(next) {
    state = next;
    dialog.dataset.roomState = next;
    stage.setAttribute('aria-busy', String(next === 'working'));
    poster.hidden = next !== 'ready';
    document.getElementById('room-hint').hidden = next !== 'ready';
    if ($('loading')) $('loading').hidden = next !== 'working';
    if ($('retry')) $('retry').hidden = next !== 'failed';
    $('keep').disabled = next !== 'ready' || !choices.length;
    size.disabled = next !== 'ready';
    if (next === 'ready') draw();
  }
  function error(key) { errorKey = key; $('error').hidden = !key; $('error').textContent = key ? copy(key) : ''; }
  function stop() { epoch++; clearTimeout(timer); if (controller) controller.abort(); controller = null; }
  var activeRoom = '', rooms = [], thumbUrls = [], positionTimer = 0, launcherUrl = '', launcherRoom = '';
  var L = window.AfRoomLibrary;
  function roomName(room) { return room.name || copy('roomNumber').replace('__NUMBER__',room.number); }
  function libraryState(library) {
    rooms = library.rooms;
    var saved = rooms.find(function(room){return room.id===library.selected;});
    var label = open.querySelector('[data-room-open-label]');
    var thumbnail = open.querySelector('[data-room-open-thumb]');
    var name = open.querySelector('[data-room-open-name]');
    var icon = open.querySelector('[data-room-open-icon]');
    if (label && thumbnail && name && icon) {
      label.textContent = saved ? label.dataset.saved : label.dataset.default;
      name.textContent = saved ? roomName(saved) : '';
      name.hidden = thumbnail.hidden = !saved;
      icon.hidden = !!saved;
      if (launcherRoom !== (saved ? saved.id : '') || (saved && !launcherUrl)) {
        if (launcherUrl) URL.revokeObjectURL(launcherUrl);
        launcherUrl = saved ? URL.createObjectURL(saved.thumb || saved.blob) : '';
        launcherRoom = saved ? saved.id : '';
        if (launcherUrl) thumbnail.src = launcherUrl; else thumbnail.removeAttribute('src');
      }
    }
    if ($('storage')) $('storage').hidden = library.persistent;
    all('saved-note').forEach(function(e){e.hidden=!library.persistent;});
  }
  function remember(patch) {
    if (!activeRoom) return Promise.resolve();
    return L.update(activeRoom,patch).then(function(result){libraryState(result.library);});
  }
  function savePosition() {
    clearTimeout(positionTimer);
    if (activeRoom && plan) return remember({centre:{x:centre.x,y:centre.y}});
    return Promise.resolve();
  }
  function display(name) {
    ['intro','workspace','library','restoring'].forEach(function(k){if ($(k)) $(k).hidden=k!==name;});
    dialog.scrollTop=0;
  }
  function validPlan(p) {
    return p && G.valid(p.coins) && Number.isFinite(p.largeur_cm) && Number.isFinite(p.hauteur_cm)
      && p.largeur_cm>=50 && p.largeur_cm<=2000 && p.hauteur_cm>=30 && p.hauteur_cm<=1000
      && p.centre && Number.isFinite(p.centre.x) && Number.isFinite(p.centre.y)
      && p.centre.x>=0 && p.centre.x<=1 && p.centre.y>=0 && p.centre.y<=1;
  }
  async function useRoom(room) {
    var saving=savePosition();stop();var id=epoch;await saving;
    if (id!==epoch || !dialog.open) return;
    var selected=await L.select(room.id); libraryState(selected.library);
    if (id!==epoch || !dialog.open || !selected.value) return;
    room=selected.value; activeRoom=room.id;
    if (fileUrl) URL.revokeObjectURL(fileUrl);
    blob=room.blob; width=room.width; height=room.height;
    fileUrl=URL.createObjectURL(blob); photo.src=fileUrl;
    photoUrl=room.photoUntil>Date.now()?room.photoUrl||'':'';
    plan=room.analysisVersion===1 && validPlan(room.plan)?room.plan:null;
    centre=plan?{x:plan.centre.x,y:plan.centre.y}:{x:.5,y:.4};
    if (plan && room.centre && Number.isFinite(room.centre.x) && Number.isFinite(room.centre.y)) {
      try {
        var pos=G.project(G.matrix(plan.coins),room.centre);
        if (pos.x>=0 && pos.x<=1 && pos.y>=0 && pos.y<=1) centre={x:room.centre.x,y:room.centre.y};
      } catch (_) {}
    }
    if ($('name')) $('name').textContent=roomName(room);
    dragging=null; error(''); display('workspace');
    if (plan) { status('estimated'); setState('ready'); layout(); }
    else { setState('working'); layout(); analyse(); }
  }
  function releaseThumbs() { thumbUrls.forEach(function(url){URL.revokeObjectURL(url);}); thumbUrls=[]; }
  function renderRooms() {
    var list=$('list'); if (!list) return;
    releaseThumbs(); list.replaceChildren();
    rooms.forEach(function(room){
      var card=document.createElement('div'), choose=document.createElement('button'), im=document.createElement('img');
      card.className='room-preview__room-card'; choose.type='button'; choose.className='room-preview__room-choice';
      choose.dataset.roomChoose=room.id; choose.setAttribute('aria-pressed',String(room.id===activeRoom));
      im.src=URL.createObjectURL(room.thumb||room.blob); thumbUrls.push(im.src); im.alt=''; im.width=240; im.height=160;
      var title=document.createElement('span');title.textContent=roomName(room);choose.append(im,title);
      choose.addEventListener('click',function(){useRoom(room);});
      var actions=document.createElement('div'), rename=document.createElement('button'), del=document.createElement('button');
      actions.className='room-preview__room-actions';rename.type=del.type='button';
      rename.textContent=copy('renameRoom');del.textContent=copy('deleteRoom');del.dataset.roomDelete=room.id;
      del.setAttribute('aria-label',copy('deleteRoom')+' : '+roomName(room));
      var input=document.createElement('input');input.type='text';input.maxLength=40;input.hidden=true;
      input.setAttribute('aria-label',copy('roomNameLabel'));input.value=roomName(room);input.dataset.roomRename=room.id;
      rename.addEventListener('click',function(){input.hidden=false;input.focus();input.select();});
      function renameRoom() {
        if (input.hidden) return;
        var focus=document.activeElement===input;input.hidden=true;var name=input.value.trim().slice(0,40);
        L.update(room.id,{name:name}).then(function(result){
          libraryState(result.library);renderRooms();
          if (focus) {var selected=$('list').querySelector('[data-room-choose="'+room.id+'"]');if(selected)selected.focus();}
          if (activeRoom===room.id && $('name')) $('name').textContent=name||roomName(Object.assign({},room,{name:''}));
        });
      }
      input.addEventListener('blur',renameRoom);
      input.addEventListener('keydown',function(e){
        if (e.key==='Enter') {e.preventDefault();renameRoom();choose.focus();}
        if (e.key==='Escape') {e.preventDefault();e.stopPropagation();input.hidden=true;rename.focus();}
      });
      del.addEventListener('click',function(){deleteRoom(room.id);});
      actions.append(rename,del);card.append(choose,input,actions);list.append(card);
    });
    if ($('library-back')) $('library-back').hidden=!activeRoom;
  }
  async function showRooms() {
    await savePosition(); libraryState(await L.read());
    if (!dialog.open) return;
    renderRooms(); display(rooms.length?'library':'intro');
  }
  async function deleteRoom(id) {
    if (id===activeRoom) {clearTimeout(positionTimer);activeRoom='';remove();}
    var result=await L.remove(id);libraryState(result.library);
    renderRooms();display(rooms.length?'library':'intro');
    if (!rooms.length) $('intro').querySelector('button').focus();
  }
  function pointAt(e) {
    var r = stage.getBoundingClientRect();
    return {x:Math.max(0,Math.min(1,(e.clientX-r.left)/r.width)),y:Math.max(0,Math.min(1,(e.clientY-r.top)/r.height))};
  }
  function dimensions(value) {
    var choice = choices.find(function(c){return c.value===value;});
    if (!choice) return null;
    if (!choice.custom) return choice.dimensions;
    return $('width').checkValidity() && $('height').checkValidity()
      ? [Number($('width').value),Number($('height').value)] : null;
  }
  function readChoice(b) {
    if (b.hidden || b.disabled || !b.getClientRects().length) return null;
    if (b.hasAttribute('data-sur-mesure')) {
      if (!document.getElementById('pdp-sm-l') || !document.getElementById('pdp-sm-h')) return null;
      return {button:b,value:'custom',custom:true,label:b.querySelector('b').textContent.trim()};
    }
    var label = b.dataset.dimensions || Array.from(b.querySelectorAll('span')).map(function(s){return s.textContent.trim();}).find(function(t){return /^\d+\s*[x×]\s*\d+\s*(?:cm)?$/i.test(t);}) || b.textContent.trim();
    var m = String(label || '').match(/^(\d+)\s*[x×]\s*(\d+)\s*(?:cm)?$/i);
    if (!m) return null;
    var grid = String(b.dataset.value).match(/(\d+)\s*[x×]\s*(\d+)\D+\d+\s*[x×]\s*\d+/i);
    return {button:b,value:b.dataset.value,dimensions:[Number(m[1]),Number(m[2])],label:label,
      grid:grid ? [Number(grid[1]),Number(grid[2])] : null};
  }
  function readChoices() {
    var group = document.querySelector('.pdp-option');
    choices = group ? Array.from(group.querySelectorAll('[data-value],[data-sur-mesure]')).map(readChoice).filter(Boolean) : [];
    var selected = choices.find(function (c) { return c.button.getAttribute('aria-pressed') === 'true'; });
    sourceSize = selected ? selected.value : '';
    var fallback = selected || choices.find(function (c) { return c.dimensions && Math.min.apply(null,c.dimensions) === 30; }) || choices[0];
    var support = document.querySelector('#pdp-support [aria-pressed="true"] .pdp-support__lab');
    if ($('support')) $('support').textContent = support ? '· '+support.textContent.trim() : '';
    ['width','height'].forEach(function(key,i){
      var input=$(key), original=document.getElementById(i?'pdp-sm-h':'pdp-sm-l');
      if (!input || !original) return;
      input.min=original.min;input.max=original.max;input.value=original.value;
    });
    size.replaceChildren();
    choices.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c.value; o.textContent = c.label; size.appendChild(o);
    });
    if (fallback) size.value = fallback.value;
    if ($('custom')) $('custom').hidden=size.value!=='custom';
    $('keep').disabled = state !== 'ready' || !fallback;
    return !!fallback;
  }
  var poly = document.createElement('div');poly.className='room-preview__poly';poly.hidden=true;
  poster.appendChild(poly);
  function drawPoly(choice, d, border, color) {
    poly.replaceChildren();
    var cols=choice.grid[0], rows=choice.grid[1];
    poly.style.gridTemplateColumns='repeat('+cols+',1fr)';
    poly.style.gridTemplateRows='repeat('+rows+',1fr)';
    for (var y=0;y<rows;y++) for (var x=0;x<cols;x++) {
      var panel=document.createElement('div'), crop=document.createElement('div'), image=art.cloneNode();
      image.removeAttribute('data-room-art');
      panel.style.padding=border*10+'px';panel.style.background=color;
      image.style.width=d[0]*10+'px';image.style.height=d[1]*10+'px';
      image.style.objectPosition='50% 50%';
      image.style.left=-x*d[0]/cols*10+'px';image.style.top=-y*d[1]/rows*10+'px';
      crop.appendChild(image);panel.appendChild(crop);poly.appendChild(panel);
    }
  }
  function draw(next) {
    if (state !== 'ready' || !plan || !dialog.open || !stage.clientWidth || !stage.clientHeight) return;
    var d = dimensions(size.value);
    if (!d) {poster.hidden=true;$('keep').disabled=true;document.getElementById('room-hint').hidden=true;return;}
    var choice=choices.find(function(c){return c.value===size.value;});
    var metal = document.documentElement.dataset.support === 'metal';
    var frame = !metal && !choice.custom && window.__pdpUpsell && window.__pdpUpsell.frameItem();
    var border = frame ? 1.8 : 0;
    var cols=choice.grid?choice.grid[0]:1, rows=choice.grid?choice.grid[1]:1;
    var w = d[0]+border*2*cols+(cols-1)*.5, h = d[1]+border*2*rows+(rows-1)*.5;
    var q = G.corners(plan, next || centre, w, h);
    if (next && !q) return;
    if (next) centre = next;
    poster.hidden = !q; $('keep').disabled = !q;
    document.getElementById('room-hint').hidden = !q;
    if (!q) { error('fit'); return; }
    if (errorKey === 'fit') error('');
    poster.style.width = w*10+'px'; poster.style.height = h*10+'px';
    poster.style.transform = G.css(q,stage.clientWidth,stage.clientHeight,w*10,h*10);
    poster.dataset.metal = String(metal);
    poster.dataset.poly = String(!!choice.grid);
    poster.style.padding = choice.grid ? '0' : border*10+'px';
    var originalFrame = document.getElementById('pdp-frame');
    var color = frame && originalFrame ? getComputedStyle(originalFrame).borderTopColor : '#fff';
    poster.style.background = choice.grid ? 'transparent' : color;
    poly.hidden=!choice.grid;$('sheet').hidden=!!choice.grid;
    if (choice.grid) drawPoly(choice,d,border,color);
    art.style.objectPosition=choice.custom && window.AfSurMesure ? window.AfSurMesure.position(d[0],d[1]) : '50% 50%';
    var B = window.AfBordure, margin = !choice.grid && B && B.propose && B.choisi === 'avec' && B.partCadre(size.value);
    $('sheet').style.padding = margin ? (margin.hautPct*d[0]/10)+'px '+(margin.cotePct*d[0]/10)+'px' : '0';
  }
  function move(p) {
    p = {x:Math.max(0,Math.min(1,p.x)),y:Math.max(0,Math.min(1,p.y))};
    try { draw(G.project(G.inverse(G.matrix(plan.coins)),p)); } catch (_) {}
  }
  function layout() {
    if (!width || !height || !dialog.open) return;
    var visual = stage.parentElement;
    var maxW = visual.clientWidth - (innerWidth <= 700 ? 24 : 40);
    var maxH = innerWidth <= 700 ? Math.max(210,Math.min(420,innerHeight*.42)) : Math.min(620,innerHeight*.68);
    var k = Math.min(maxW/width,maxH/height);
    stage.style.width = width*k+'px'; stage.style.height = height*k+'px';
    draw();
  }
  async function request(url, options, signal) {
    var r = await fetch(url, Object.assign({mode:'cors',credentials:'omit',signal:signal},options));
    if (!r.ok) throw new Error('network');
    return r.json();
  }
  function failed() {
    plan = null; dragging = null; status('manual'); setState('failed');
  }
  async function analyse() {
    if (!blob || !dialog.open) return;
    stop(); var id = epoch;
    controller = new AbortController(); var signal = controller.signal;
    plan = null; dragging = null; error(''); setState('working'); status('working');
    var timeout = setTimeout(function () { if (id === epoch) { stop(); failed(); } }, 120000);
    try {
      var uploadedNow = false;
      if (!photoUrl) {
        var uploaded = await request(API+'/photo',
          {method:'POST',headers:{'Content-Type':'image/jpeg'},body:blob},signal);
        if (id !== epoch) return;
        photoUrl = uploaded.url; uploadedNow = true;
        remember({photoUrl:photoUrl,photoUntil:Date.now()+9*60*1000});
      }
      var answer = uploadedNow ? {etat:'absent'} : await request(API+'?u='+encodeURIComponent(photoUrl),{},signal);
      if (answer.etat === 'absent') answer = await request(API,{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({url:photoUrl,width:width,height:height})},signal);
      while (answer.etat === 'en_cours') {
        await new Promise(function (resolve) {
          function done() { clearTimeout(timer); signal.removeEventListener('abort',done); resolve(); }
          timer = setTimeout(done,1800);
          signal.addEventListener('abort',done,{once:true});
          if (signal.aborted) done();
        });
        if (id !== epoch) return;
        answer = await request(API+'?u='+encodeURIComponent(photoUrl),{},signal);
      }
      if (id !== epoch) return;
      var p = answer.plan;
      if (answer.etat === 'pret' && validPlan(p)) {
        plan = p; centre = {x:p.centre.x,y:p.centre.y};
        remember({plan:p,centre:centre,analysisVersion:1,photoUrl:'',photoUntil:0});
        status('estimated'); setState('ready');
      } else { photoUrl = ''; remember({photoUrl:'',photoUntil:0}); failed(); }
    } catch (_) { if (id === epoch) failed(); }
    finally { clearTimeout(timeout); }
  }
  async function loadFile(file) {
    if (!file) return;
    if (!file.type.startsWith('image/') || file.size > 30*1024*1024) { error('photoError'); return; }
    var saving=savePosition();stop();var id=epoch;
    plan = null; dragging = null; error(''); setState('working'); status('working');
    await saving;
    if (id!==epoch || !dialog.open) return;
    var local=URL.createObjectURL(file);
    try {
      var im = new Image(); im.src = local; await im.decode();
      if (id !== epoch) return;
      if (im.naturalWidth < 100 || im.naturalHeight < 100) throw new Error('small');
      var k = Math.min(1,1600/Math.max(im.naturalWidth,im.naturalHeight));
      var c = document.createElement('canvas'); c.width = Math.round(im.naturalWidth*k); c.height = Math.round(im.naturalHeight*k);
      var ctx = c.getContext('2d'); ctx.fillStyle='#fff'; ctx.fillRect(0,0,c.width,c.height); ctx.drawImage(im,0,0,c.width,c.height);
      var normalized = await new Promise(function (resolve) { c.toBlob(resolve,'image/jpeg',.88); });
      if (id !== epoch) return;
      if (!normalized) throw new Error('photo');
      var thumbCanvas=document.createElement('canvas'), scale=Math.min(1,320/Math.max(c.width,c.height));
      thumbCanvas.width=Math.round(c.width*scale);thumbCanvas.height=Math.round(c.height*scale);
      thumbCanvas.getContext('2d').drawImage(c,0,0,thumbCanvas.width,thumbCanvas.height);
      var thumb=await new Promise(function(resolve){thumbCanvas.toBlob(resolve,'image/jpeg',.75);});
      var digest=await crypto.subtle.digest('SHA-256',await normalized.arrayBuffer());
      var key=Array.from(new Uint8Array(digest)).map(function(n){return n.toString(16).padStart(2,'0');}).join('');
      if (id!==epoch) return;
      var saved=await L.add({id:key,blob:normalized,thumb:thumb,width:c.width,height:c.height});
      libraryState(saved.library);
      if (id!==epoch || !dialog.open) return;
      activeRoom=''; await useRoom(saved.value);
    } catch (_) { if (id === epoch) { failed(); error('photoError'); } }
    finally { URL.revokeObjectURL(local); $('file').value=''; }
  }
  function remove() {
    stop(); if (fileUrl) URL.revokeObjectURL(fileUrl);
    fileUrl=''; photoUrl=''; blob=null; plan=null; width=0; height=0; dragging=null; setState('empty');
    photo.removeAttribute('src'); $('intro').hidden=false; $('workspace').hidden=true; error('');
  }
  function close() { dialog.close(); }
  setState('empty');
  open.hidden = false;
  L.read().then(libraryState);
  open.addEventListener('click',async function () {
    if (dialog.open) return;
    if (!readChoices()) return;
    scroll=window.scrollY; oldBody={};
    ['position','top','left','width','overflow'].forEach(function(k){oldBody[k]=document.body.style[k];});
    Object.assign(document.body.style,{position:'fixed',top:-scroll+'px',left:'0',width:'100%',overflow:'hidden'});
    dialog.showModal(); art.src=dialog.dataset.image;display('restoring');
    var id=epoch, library=await L.read();libraryState(library);
    if (!dialog.open || id!==epoch) return;
    var selected=rooms.find(function(room){return room.id===library.selected;});
    if (selected) await useRoom(selected);
    else {activeRoom='';remove();renderRooms();display(rooms.length?'library':'intro');}
  });
  dialog.addEventListener('close',function () {
    savePosition(); stop(); dragging=null;
    if (oldBody) { Object.assign(document.body.style,oldBody); oldBody=null; window.scrollTo(0,scroll); }
    open.focus({preventScroll:true});
  });
  $('close').addEventListener('click',close);
  all('upload').forEach(function(b){b.addEventListener('click',function(){$('file').click();});});
  $('file').addEventListener('change',function(){loadFile(this.files[0]);});
  $('remove').addEventListener('click',function(){if(activeRoom)deleteRoom(activeRoom);else remove();});
  all('switch').forEach(function(b){b.addEventListener('click',showRooms);});
  if ($('library-back')) $('library-back').addEventListener('click',function(){display('workspace');layout();});
  size.addEventListener('change',function(){if($('custom'))$('custom').hidden=size.value!=='custom';draw();});
  ['width','height'].forEach(function(key){if($(key))$(key).addEventListener('input',function(){draw();});});
  if ($('retry')) $('retry').addEventListener('click',analyse);
  $('keep').addEventListener('click',function () {
    if (state !== 'ready' || poster.hidden) return;
    var choice=choices.find(function(c){return c.value===size.value;});
    if (!choice || choice.button.disabled || choice.button.hidden || !dimensions(size.value)) return;
    if (choice.custom) {
      ['width','height'].forEach(function(key,i){
        var input=document.getElementById(i?'pdp-sm-h':'pdp-sm-l');
        input.value=$(key).value;input.dispatchEvent(new Event('input',{bubbles:true}));
      });
    }
    if (size.value!==sourceSize) choice.button.click();
    close();
  });
  stage.addEventListener('pointerdown',function(e){
    if (state !== 'ready' || !plan || poster.hidden || dragging || (e.pointerType==='mouse' && e.button!==0)) return;
    var p=pointAt(e), pos=G.project(G.matrix(plan.coins),centre);
    dragging={id:e.pointerId,offset:{x:pos.x-p.x,y:pos.y-p.y}};
    stage.setPointerCapture(e.pointerId); e.preventDefault();
  });
  stage.addEventListener('pointermove',function(e){
    if (!dragging || dragging.id!==e.pointerId) return;
    var p=pointAt(e);
    move({x:p.x+dragging.offset.x,y:p.y+dragging.offset.y});
  });
  ['pointerup','pointercancel','lostpointercapture'].forEach(function(name){stage.addEventListener(name,function(e){if(dragging&&dragging.id===e.pointerId){dragging=null;savePosition();}});});
  stage.addEventListener('keydown',function(e){
    var dirs={ArrowLeft:[-1,0],ArrowRight:[1,0],ArrowUp:[0,-1],ArrowDown:[0,1]}, d=dirs[e.key];
    if(!d || state !== 'ready' || !plan || e.target !== poster || poster.hidden)return;
    var step=e.shiftKey?.03:.008, p=G.project(G.matrix(plan.coins),centre);
    e.preventDefault();move({x:p.x+d[0]*step,y:p.y+d[1]*step});
    clearTimeout(positionTimer);positionTimer=setTimeout(savePosition,150);
  });
  new ResizeObserver(layout).observe(stage.parentElement);
  window.addEventListener('resize',layout);
  window.addEventListener('pagehide',function(){savePosition();stop();releaseThumbs();if(launcherUrl)URL.revokeObjectURL(launcherUrl);launcherUrl='';});
  window.addEventListener('pageshow',function(e){
    if (e.persisted) L.read().then(libraryState);
    if (!e.persisted || !dialog.open) return;
    if ($('library') && !$('library').hidden) showRooms();
    else if (blob && state==='working') analyse();
  });
})();
